import { initializeStudentStorage } from './privacy/studentStorage';
import { prepareEncryptedDatabases } from './privacy/encryptedDatabase';

async function start() {
  await initializeStudentStorage();
  const [statistics] = await Promise.all([
    import('./services/studentStatisticsService'),
    import('./services/adaptiveReviewService'),
  ]);
  statistics.initializeLocalLearningOwner();
  await prepareEncryptedDatabases();
  await import('./pwaRoot');
}

void start().catch(() => {
  const root = document.getElementById('root');
  if (!root) return;
  const message = document.createElement('p');
  message.textContent = 'Dein Lerntresor konnte nicht geöffnet werden. Deine vorhandenen Daten wurden nicht zurückgesetzt. Schließe andere FUSICS-Tabs und versuche es erneut. Falls dein Browserprofil beschädigt ist, kannst du deine Sicherungsdatei mit ihrem Schlüssel in einem neuen Browserprofil wiederherstellen.';
  const button = document.createElement('button');
  button.textContent = 'Erneut versuchen';
  button.onclick = () => window.location.reload();
  root.replaceChildren(message, button);
});
